module.exports = __webpack_public_path__ + "img/spin_btn.8ccd0193.png";